import type { SVGProps } from 'react';

export function BishopIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 1c.465 0 .92.135 1.306.388s.685.613.859 1.032.214.88.117 1.322a2.25 2.25 0 0 1-.665 1.159q1.13.477 2.03 1.153l-4.472 4.345-.097.106a1.11 1.11 0 0 0 .098 1.496 1.19 1.19 0 0 0 1.54.094l.109-.094 4.45-4.321C18.415 9.21 19 11.16 19 13.467c0 2.168-1.374 4.218-3.604 4.502l-.233.023-.246.008H9.083C6.603 18 5 15.82 5 13.467c0-4.171 1.832-7.09 5.382-8.568a2.25 2.25 0 0 1-.663-1.16 2.2 2.2 0 0 1 .118-1.32c.174-.419.473-.778.858-1.03C11.081 1.134 11.535 1 12 1M12 5v1zM18.858 19H5.143a1.23 1.23 0 0 0-.808.293A.94.94 0 0 0 4 20c0 .53.24 1.04.67 1.414.428.375 1.01.586 1.616.586h11.429c.56 0 1.1-.18 1.52-.506.418-.326.686-.775.75-1.262l.013-.174a.9.9 0 0 0-.067-.4 1 1 0 0 0-.242-.344 1.2 1.2 0 0 0-.379-.232 1.3 1.3 0 0 0-.452-.082" />
    </svg>
  );
}
